import { StyleObj } from '../../@types';
import { SkinStylesMap } from '../../hooks/useSkinStyles';
import { SKIN } from '../../types/enums';

const BET365_STYLES: StyleObj = {
  container: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    backgroundColor: 'neutral.600',
    borderRadius: {
      xs: 1,
      md: 2,
    },
    p: {
      xs: 4,
      md: 6,
    },
  },
  icon: {
    color: 'info.main',
  },
  text: {
    typography: {
      xs: 'h5',
      md: 'h3',
    },
  },
};

const NEOBET_STYLES: StyleObj = {
  container: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1.5,
    minHeight: 160,
    backgroundColor: 'neutral.600',
    border: 'none',
    borderRadius: {
      xs: 3,
      md: 3.5,
    },
    px: {
      xs: 3,
      md: 4,
    },
    py: {
      xs: 4,
      md: 5,
    },
  },
  icon: {
    color: 'info.100',
    fontSize: {
      xs: 20,
      md: 24,
    },
  },
  text: {
    color: 'neutral.200',
    typography: {
      xs: 'subtitle2',
      md: 'h5',
    },
    fontWeight: 700,
    textAlign: 'center',
  },
};

export const EMPTY_STATE_MESSAGE_SKIN_STYLES: SkinStylesMap<StyleObj> = {
  [SKIN.BET365]: BET365_STYLES,
  [SKIN.GOLA]: BET365_STYLES,
  [SKIN.NEOBET]: NEOBET_STYLES,
};
